$(function () {
  $(window).on('load', function () {
    $("#js-loader").fadeOut(); // これだけでOK
  });
})


//　list_item
$(function () {
  $(".block_list_item_wrapper").fadeOut();
  $("#all").fadeIn();
  $(".block_list_item ul li").on("click", function () {
    $(".block_list_item ul li").removeClass("active");
    var now_click = "#" + $(this).data("link");
    $(this).addClass("active");
    $(".block_list_item_wrapper").fadeOut();
    $(now_click).fadeIn();
  })
})

// qa
$(function () {
  $(".block_qa dl dt").on("click", function () {
    $(this).toggleClass("open");
    $(this).next("dd").slideToggle();
  })
})

// fv
$(function () {
  var swiper;
  swiper = new Swiper('.box_fv_container', {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2.4,
        spaceBetween: 0,
      },
    },
    pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
    },
  });
});



// スクロールのドラッグ有効化
jQuery.prototype.mousedragscrollable = function () {
  let target;
  $(this).each(function (i, e) {
    $(e).mousedown(function (event) {
      event.preventDefault();
      target = $(e);
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
      return false;
    });
    $(e).click(function (event) {
      if ($(e).data("move")) {
        return false;
      }
    });
  });
  $(document)
    .mousemove(function (event) {
      if ($(target).data("down")) {
        event.preventDefault();
        let move_x = $(target).data("x") - event.clientX;
        let move_y = $(target).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $(target).data("move", true);
        } else {
          return;
        }
        $(target).scrollLeft($(target).data("scrollleft") + move_x);
        $(target).scrollTop($(target).data("scrolltop") + move_y);
        return false;
      }
    })
    .mouseup(function (event) {
      $(target).data("down", false);
      return false;
    });
};
$(".scroll").mousedragscrollable();
